module.exports = __webpack_public_path__ + "img/whatsapp-share.c3d2cd72.svg";